export default __webpack_public_path__ + "static/lutein-wet-wipe-promo-no1-2b89af4f49c1e60fa7a15abc04749eae.jpg";